module.exports = __webpack_public_path__ + "img/DE00590.edc3a60c.png";